import React from "react";
import "./PriorityTagDisplay.scss";

interface PriorityTagDisplayProps {
  size?: string;
  backgroundColor?: string;
  color?: string;
  label?: string;
}

const PriorityTagDisplay: React.FC<PriorityTagDisplayProps> = ({
  size = "",
  backgroundColor,
  color,
  label,
}) => {
  return (
    <div
      className={`priority-tag-wrap ${
        size === "l" ? "size-large" : "size-small"
      }`}
      style={{
        backgroundColor,
        color,
      }}
    >
      <span>{!!label && label}</span>
    </div>
  );
};

export default PriorityTagDisplay;
